import { STRINGS_EN, azureTables, tableActions } from "../../../../constant";
import useTableOperations from "../../../../hooks/useTableOperations";
import NoEntryExit from "../NoEntryExist";
import UpdateTeamsContext from "../UpdateTeamsContext";

function FilterRoatserAccounts({ email }) {
  const userEntity = {
    email: email,
  };

  const {
    loading,
    error,
    data: roasterData,
  } = useTableOperations(
    azureTables.MERLINASSISTROASTERINFO,
    tableActions.FILTER,
    userEntity
  );

  if (loading) {
    return <>{STRINGS_EN.LOADING}</>;
  }
  if (error) {
    return <>{STRINGS_EN.ERROR}</>;
  }
  if (roasterData?.length === 0) {
    return <NoEntryExit email={email} />;
  }

  return (
    <>
      {roasterData && roasterData.length > 0 && (
        <UpdateTeamsContext contextInfo={roasterData[0]} />
      )}
    </>
  );
}

export default FilterRoatserAccounts;
